import {AIRecommendationsAnalyticsData, IAnalyticsService} from './analytics.service.interface';
import {ServiceBase} from '../ServiceBase';
import {IElasticEventData, IStructuredLogger} from '../../../common/interfaces/structured-logging-service-interface';

export class AnalyticsService extends ServiceBase implements IAnalyticsService {

  sendAnalytics(
    category: string,
    action: string | undefined = undefined,
    label: string | undefined = undefined,
    value: string | undefined = undefined,
    omitStructuredLogger?: boolean
  ) {
    this.services.sdk.sendAnalytics(category, action, label, value, omitStructuredLogger);
  }

  sendAIRecommendations(data: AIRecommendationsAnalyticsData): void {
    this.sendAnalytics(data.category, JSON.stringify(data.gameTypes), data.engine);
  }

  sendTechnicalEvent(action: string, label?: string, value?: any): void {
    this.sendAnalytics('[Technical-event]', action, label, value);
  }

  sendElasticInfoEvent(category: string, action: string, eventLabel?: string, value?: string, customData?: object) {
    this.services.sdk.structuredLoggingService
      .getLogger()
      .addCategory(category)
      .addAction(action)
      .addLabel(eventLabel)
      .addValue(value)
      .addCustomData(customData)
      .info();
  }

  getLogger(eventData?: IElasticEventData): IStructuredLogger {
    return  this.services.sdk.structuredLoggingService.getLogger(eventData);
  }

  getGoogleClientID(): string {
    return this.services.sdk.getGoogleClientID();
  }
}
